module.exports = __webpack_public_path__ + "img/2J.35e3b5a6.png";